import * as assert from 'assert';
import { computed } from 'mobx';
import * as moment from 'moment';

export enum FamilyName {
    MY_STUFF = 'My Stuff',
    ALL = 'All'
}

export interface IFamilyUser {
    user_id: number;
    family_id: number;
    is_admin: boolean;
    joined_at: string;
}

export interface INewFamily {
    name: string;
}

export interface ICollectionInfo {
    collection_id: number;
    added_at: Date;
}

export interface IUserInfo {
    user_id: number;
    joined_at: Date;
}

export interface IServerFamily {
    id: number;
    name: string;
    user_id: number;
    created_at: string; // date string
    collections_info: Array<ICollectionInfo>;
    users_info: Array<IUserInfo>;
}

export class Family {
    public id: number;
    public name: string;
    public user_id: number;
    public created_at: moment.Moment;
    public collections_info: Array<ICollectionInfo>;
    public users_info: Array<IUserInfo>;

    public userMap: Map<number, IUserInfo> = new Map();
    public collectionMap: Map<number, ICollectionInfo> = new Map();

    public constructor(args: IServerFamily) {
        assert(args);
        assert(typeof args.id === 'number', 'Family#constructor invalid id');
        assert(typeof args.name === 'string', 'Family#constructor invalid name');
        assert(typeof args.user_id === 'number', 'Family#constructor invalid user_id');
        assert(typeof args.created_at === 'string', 'Family#constructor invalid created_at');

        assert(Array.isArray(args.collections_info), 'Family#constructor invalid collections_info');
        assert(Array.isArray(args.users_info), 'Family#constructor invalid users_info');

        this.id = args.id;
        this.name = args.name;
        this.user_id = args.user_id;
        this.created_at = moment(args.created_at);

        this.collections_info = args.collections_info;
        this.users_info = args.users_info;

        this.users_info.forEach((userInfo) => this.userMap.set(userInfo.user_id, userInfo));
        this.collections_info.forEach((collectionInfo) => this.collectionMap.set(collectionInfo.collection_id, collectionInfo));
    }

    @computed
    public get user_ids(): Array<number> {
        return this.users_info.map((info) => info.user_id);
    }

    @computed
    public get collection_ids(): Array<number> {
        return this.collections_info.map((info) => info.collection_id);
    }

    public getUserJoinDate(user_id: number) {
        assert(this.userMap.has(user_id), 'Family#getUserJoinDate - requested unknown user_id: ' + user_id);
        const userInfo = this.userMap.get(user_id);
        if (userInfo) {
            return moment(userInfo.joined_at);
        }
        return moment();
    }

    public getCollectionAddDate(collection_id: number) {
        assert(this.collectionMap.has(collection_id), 'Family#getCollectionAddDate - requested unknown collection_id: ' + collection_id);
        const collectionInfo = this.collectionMap.get(collection_id);
        if (collectionInfo) {
            return moment(collectionInfo.added_at);
        }
        return moment();
    }
}



// WEBPACK FOOTER //
// ./src/_interfaces/Family.ts